import { useQuery } from '@tanstack/react-query'

import { FetchFeatureFlags } from '@/services/FeatureFlagService'

export const useFeatureFlags = () => {
  return useQuery({
    queryKey: ['feature-flags'],
    queryFn: FetchFeatureFlags,
  })
}
